/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react'
import moment from 'moment'
import LazyLoad from 'react-image-lazy-load';
import { sortByKey } from 'lib/services';
import { RecipeBottomIcon } from '../recipeList/RecipeData'

class MobileRecipeData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ...props
    }
  }
	
  //  eslint-disable-next-line
	UNSAFE_componentWillReceiveProps(props) {
    this.setState({ ...props})
    console.log(props)
  }

  prepPlan(){
    const { cookDay } = this.state
    return(
      <div>
        {
          cookDay.map((item, index)=>{
            const cookDate = moment(item.cooking_date).format('MM/DD')
            return(
              <div className="dash-cntnt-dtail-hdr cook-day-top vrt-chngs" key={item.cooking_date}>
                <div className="heade_title topBorderNone">
                  <div className="sub-heading">
                    <h4>Prep Day {index+1}:  {item.cooking_day} {cookDate}</h4>
                  </div>
                  <div className="cook-time">
                    <span className="ttl-cook-time">
                      <img src="/images/active_time.png" alt="hands"/>
                      <span className="hands"> {item.totalHands} </span>
                    </span>
                    <span className="ttl-cook-time">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                        viewBox="0 0 100 100" style={{enableBackground:"new 0 0 100 100"}} xmlSpace="preserve" height="20" width="20">
                        <g>
                          <path d="M50,5C25.2,5,5,25.2,5,50s20.1,45,45,45s45-20.1,45-45S74.8,5,50,5z M50,89.7c-21.9,0-39.7-17.8-39.7-39.7   c0-21.9,17.8-39.7,39.7-39.7S89.7,28.1,89.7,50C89.7,71.9,71.9,89.7,50,89.7z" />
                          <path d="M52.4,51.7V25.2c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4v27.3c0,0.3,0.1,0.6,0.1,0.8c0.1,0.4,0.3,0.8,0.6,1.1l19.3,19.3   c0.9,0.9,2.5,0.9,3.4,0c0.9-0.9,0.9-2.5,0-3.4L52.4,51.7z" />
                        </g>
                      </svg> 
                      <span> {item.totalTime} </span>
                    </span>
                  </div>
                  {
                    this.recipeData(item.recipe,'prep','rcp-list')
                  }
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }
  mealPlan(){
    const { mealDay, dayDates, notesArr } = this.state
    return(
      <div>
        {
          dayDates.map((item)=>{
            const itemDate = `${item.Year}-${item.Month}-${item.date}`;
            const index = mealDay.findIndex(x=>x.cooking_date === itemDate)
            const notesDate = notesArr.findIndex(x=>x.date === itemDate)
            // const cookDate = moment(item.cooking_date).format('MM/DD')
            const editNotes = notesDate > -1
            if(index > -1)
              mealDay[index].recipe = mealDay[index].recipe.sort(sortByKey('index','asc'))
            return(
              <div className="dash-cntnt-dtail-hdr cook-day-top vrt-chngs" key={itemDate}>
                <div className="heade_title topBorderNone">
                  <div className="sub-heading">
                    <h4>{item.day} {item.Month}/{item.date}</h4>
                  </div>
                  {editNotes && 
                      <div className="notes-section" >
                        <span className="add-notes">
                          <b>Notes: </b>
                          {notesArr[notesDate].content}
                              
                          <svg className="mb-hide" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    
                            <title>DC804DE8-AFE8-40F5-A154-5E9137121B46</title>
                            <desc>Created with sketchtool.</desc>
                            <defs>
                              <path d="M0.7,10.6753645 L0.7,13.3 L3.32463547,13.3 L11.0655603,5.55907513 L8.44092487,2.93443966 L0.7,10.6753645 Z M13.0952788,3.52935706 C13.3682409,3.25639497 13.3682409,2.81545621 13.0952788,2.54249412 L11.4575062,0.904721569 C11.1845441,0.631759477 10.7436054,0.631759477 10.4706433,0.904721569 L9.18982115,2.18554369 L11.8144566,4.81017919 L13.0952788,3.52935706 Z" id="path-1" />
                            </defs>
                            <g id="Aug-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <g id="M-Dashboard-1-Copy" transform="translate(-246.000000, -1576.000000)">
                                <g id="Add-Notes-Chip-Copy-3" transform="translate(234.000000, 1570.000000)">
                                  <g id="Icon-/-Action-/-Edit" transform="translate(12.000000, 6.000000)">
                                    <mask id="mask-2" fill="white">
                                      <use xlinkHref="#path-1" />
                                    </mask>
                                    <use id="Edit" fill="#979797" fillRule="nonzero" xlinkHref="#path-1" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </span>
                      </div>
                  }
                      
                  {index >-1 ?
                    this.recipeData(mealDay[index].recipe,'meal', 'rcp-list'):
                    <div className="noMeals"><span>No Meals Planned</span></div>
                  }
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }



  recipeData(recipe, mealType, listName) {
    const { activeCard, cardClass, recipeIds } = this.state
    return recipe.map(item=>{
      const image = item.recipe.recipeImage
      // const viewRecipe = mealType === 'meal' || item.isBundle === 0 
      // const setImage = image
      let sideName = null
      const rIndex = recipeIds.findIndex(x=>x.id === item.recipe.id)
      const totalServing = rIndex >-1 ? recipeIds[rIndex].size : item.servingSize
      if(item.sideRecipe) {
        sideName = item.sideRecipe.name
      }
      item.recipe_sides = item.sideRecipe
      item.totalHands = item.activeTime
      if((mealType !== 'meal' && item.isBundle !== 1) || (mealType === 'meal')){
        return(
          <div key={item.id} className={listName}>
            {mealType === 'meal' && <span className="meal-typ">{item.type}</span>}
            <div className="meal-post small-device vrt-chngs"
              // eslint-disable-next-line
          key={`${item.id}${mealType}`}
              onClick={()=>this.props.viewRecipe(
                item, item.recipe.name, sideName, totalServing 
              )}
            >
              <a>
                <div className="headerSec">
                  <div className="image-plus-chips">
                    <LazyLoad
                      loaderImage
                      originalSrc={image}
                      imageProps={{
                        src: '/images/small.png',
                        draggable: false,
                        name: 'd.',
                      }}
                      offsetLeft={window.innerWidth}
                      offsetHorizontal={360}
                      className="cook-recipe"
                    />
                  </div>

                </div>
                <div className="mb-rcp">
                  <h5> {item.name} </h5>
                  <p className="aftr-hdng middle-text">{sideName}</p>
                  <div className="mb-only" style={{display: 'block'}}>
                    <RecipeBottomIcon
                      totalHands={item.activeTime}
                      totalTime={item.totalTime}
                      servingSize={item.servingSize}
                      // calories={item.calories}
                      mealType={mealType}
                      isBundle={item.isBundle}
                      equipmentIcon={item.equipmentIcon}
                      showClass={`${cardClass} mb-only`}
                      cardClass={cardClass}
                      activeCard={activeCard}
                    />
                  </div>
                </div>
              </a>
            </div>
          </div>
        )
      } else if(mealType !== 'meal') {
        return( 
          <div className="bundle-mob-rcp">
            <div className="bun-dtl">
              <h2>Bundle: {item.name}</h2>
              <div className="cook-time">
                <span className="ttl-cook-time">
                  <img src="/images/active_time.png" alt="hands"/>
                  <span className="hands"> {item.totalHands} </span>
                </span>
                <span className="ttl-cook-time">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                    viewBox="0 0 100 100" style={{enableBackground:"new 0 0 100 100"}} xmlSpace="preserve" height="20" width="20">
                    <g>
                      <path d="M50,5C25.2,5,5,25.2,5,50s20.1,45,45,45s45-20.1,45-45S74.8,5,50,5z M50,89.7c-21.9,0-39.7-17.8-39.7-39.7   c0-21.9,17.8-39.7,39.7-39.7S89.7,28.1,89.7,50C89.7,71.9,71.9,89.7,50,89.7z" />
                      <path d="M52.4,51.7V25.2c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4v27.3c0,0.3,0.1,0.6,0.1,0.8c0.1,0.4,0.3,0.8,0.6,1.1l19.3,19.3   c0.9,0.9,2.5,0.9,3.4,0c0.9-0.9,0.9-2.5,0-3.4L52.4,51.7z" />
                    </g>
                  </svg> 
                  <span> {item.totalTime} </span>
                </span>
              </div>
            </div>
            {item.bundleRecipe.length >0 && this.recipeData(item.bundleRecipe,'prep','rcp-list bundle')}
          </div>
        )
      }
      return null;
    })
  }

  render() {
    const { activeCard } = this.state
    // alert(activeCard)
    return(
      <div>
        {
          activeCard ==='prep'?
            this.prepPlan() 
            :
            this.mealPlan()
        }
      </div>
    )
  }
}

export default MobileRecipeData


// WEBPACK FOOTER //
// ./src/components/dashboard/MobileRecipeData.js